import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

    showSearchMenu: {
      show: false,
      style: "background-color: #43207c; color: #cecece"
    },
    elementToSearchOfGridMenu: [],
    elementOfDelivery: {},
    reloadPage: false,
    showHeader: true
  },

  mutations: {

    
    SET_showSearchMenu: (state, payload) => {
      state.showSearchMenu = payload;
    },

    SET_elementToSearchOfGridMenu: (state, payload) => {
      state.elementToSearchOfGridMenu = payload;
    },

    SET_elementOfDelivery: (state, payload) => {
      state.elementOfDelivery = payload;
    },

    SET_reloadPage:  (state, payload) => {
      state.reloadPage = payload;
    },
    SET_showHeader:  (state, payload) => {
      state.showHeader = payload;
    },
  },

  getters: {
    
    GET_showSearchMenu: state => {
      return state.showSearchMenu;
    },

    GET_elementToSearchOfGridMenu: state => {
      return state.elementToSearchOfGridMenu;
    },

    GET_elementOfDelivery: state => {
      return state.elementOfDelivery;
    },
    
    GET_reloadPage: state => {
      return state.reloadPage;
    },
    GET_showHeader: state => {
      return state.showHeader;
    },
  },

  actions: {

  },
});
